import Http from "@/libraries/Http";
/**
 * This is just like ProjectService - it uses the same controller, but operates on Planning interface.
 */
export default {
    apiVersion: "v1",
    RESTroute: "project-stages",

    async GET_boardStatus(project_id, params = {}) {
        return Http.get(
            `/${this.apiVersion}/${this.RESTroute}/board-status/${project_id}`,
            { params: params }
        );
    },

    async GET_board(project_id, params = {}) {
        return Http.get(
            `/${this.apiVersion}/${this.RESTroute}/board/${project_id}`,
            { params: params }
        );
    },

    /**
     * Get all resources
     * GET /resource
     */
    async GET(params = {}) {
        return Http.get(`/${this.apiVersion}/${this.RESTroute}`, {
            params: params
        });
    },

    /**
     * Get single resource
     * GET /resource/<id>
     */
    async GETS(id, params = {}) {
        return Http.get(`/${this.apiVersion}/${this.RESTroute}/${id}`, {
            params: params
        });
    },

    /**
     * Create resource
     * POST /resource
     * Payload: {}
     */
    async POST(data) {
        return Http.post(`/${this.apiVersion}/${this.RESTroute}`, data);
    },

    /**
     * Put resource
     * PUT /resource/<id>
     * Payload: {}
     */
    async PUT(data) {
        return Http.put(
            `/${this.apiVersion}/${this.RESTroute}/${data.id}`,
            data
        );
    },

    /**
     * Delete resource
     * DELETE /resource/<id>
     */
    async DELETE(id) {
        return Http.delete(`/${this.apiVersion}/${this.RESTroute}/${id}`);
    }
};
